(function () {
  var interfaceTranslations = {};
  var translationElement = document.getElementById('ThemeInterfaceTranslations');
  if (translationElement) { try { interfaceTranslations = JSON.parse(translationElement.textContent); } catch (e) {} }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + n;
  }

  // ------ Cart drawer open/close ------
  function openDrawer() {
    var d = $('#CartDrawer');
    var b = $('[data-cart-backdrop]');
    if (!d) return;
    d.classList.add('is-open');
    if (b) b.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('#CartDrawer');
    var b = $('[data-cart-backdrop]');
    if (!d) return;
    d.classList.remove('is-open');
    if (b) b.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-open-cart], .cart-pill');
    if (trigger && !trigger.matches('a[href="/cart"]:not(.cart-pill)')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-backdrop]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
  });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

  // ------ Cart fetch + render ------
  function fetchCart() {
    return fetch((window.Shopify.routes.root + 'cart.js'), { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
  }

  function updateBadges(cart) {
    $$('[data-cart-count], [data-cart-item-count]').forEach(function(el){ el.textContent = cart.item_count; });
    $$('[data-cart-subtotal], [data-cart-total]').forEach(function(el){ el.textContent = money(cart.total_price); });
    var threshold = parseInt(document.documentElement.getAttribute('data-free-ship') || '12000', 10);
    var remaining = Math.max(0, threshold - cart.total_price);
    var pct = threshold > 0 ? Math.min(100, (cart.total_price / threshold) * 100) : 0;
    $$('[data-ship-fill]').forEach(function(el){ el.style.width = pct + '%'; });
    $$('[data-ship-text]').forEach(function(el){
      if (remaining > 0) el.innerHTML = (interfaceTranslations.shipping_progress || "You're __AMOUNT__ away from free shipping").replace('__AMOUNT__', '<strong>' + money(remaining) + '</strong>') + ' ✨';
      else el.innerHTML = '<strong>' + (interfaceTranslations.shipping_unlocked || 'Free shipping unlocked') + '</strong> ✨';
    });
  }

  function refreshCart() {
    fetchCart().then(function(cart) {
      updateBadges(cart);
      // Re-render the drawer items by fetching the section
      fetch(window.location.pathname + '?sections=cart-drawer-render').catch(function(){});
      // Simpler: just reload the drawer markup chunk by fetching /cart and replacing the body
      fetch((window.Shopify.routes.root + 'cart?view=drawer'), { headers: { 'Accept': 'text/html' } }).then(function(r){ return r.text(); }).then(function(html){
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-items]');
          var cur   = document.querySelector('#CartDrawer [data-cart-items]');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        } catch(e) {}
      }).catch(function(){});
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
  }

  function changeLine(key, qty) {
    return fetch((window.Shopify.routes.root + 'cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); });
  }

  document.addEventListener('click', function(e) {
    var row = e.target.closest('.cart-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qtyEl = row.querySelector('[data-qty]');
    var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

    if (e.target.matches('[data-qty-plus]') || e.target.closest('[data-qty-plus]')) {
      e.preventDefault();
      changeLine(key, qty + 1).then(refreshCart);
    } else if (e.target.matches('[data-qty-minus]') || e.target.closest('[data-qty-minus]')) {
      e.preventDefault();
      changeLine(key, Math.max(0, qty - 1)).then(refreshCart);
    } else if (e.target.matches('[data-remove]')) {
      e.preventDefault();
      changeLine(key, 0).then(refreshCart);
    }
  });

  // ------ AJAX add (drawer upsell, PDP if available) ------
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('[data-cart-add-form], #PdpForm, form[action$="/cart/add"]')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch((window.Shopify.routes.root + 'cart/add.js'), { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(){
        refreshCart();
        openDrawer();
      })
      .catch(function(){});
  });
})();


